import * as agentsActions from '../actions/agents';
import * as fetchingState from '../constants/fetchingState';
import { agents } from '../constants/settingTypes';
import { getErrorMessage } from '../constants/errorCode';

export default function (settings, action) {
    settings = { ...settings, [agents]: updateActiveAgents(settings[agents], action) };
    return settings;
}

const updateActiveAgents = (state, action) => {
    switch (action.type) {
        case agentsActions.FETCH_ACTIVE_AGENTS: {
            return { ...state, activeFetching: fetchingState.FETCHING, error: undefined };
        }
        case agentsActions.SUCCESS_ACTIVE_AGENTS: {
            return { ...state, activeFetching: fetchingState.FETCHED, active: action.data, error: getErrorMessage(action.data.error) };
        }
        case agentsActions.FAILURE_ACTIVE_AGENTS: {
            return { ...state, activeFetching: fetchingState.FAILED, active: action.data, error: getErrorMessage(action.data.error) };
        }
        default: return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/agentsReducer.js